import React, { useContext, useEffect } from "react";
import { MapboxContainerContext } from "../MapboxContainer";

type MapLayerProps = {
  id: string;
  belowLayer?: string;
};
type MapRasterLayerProps = MapLayerProps & {
  source: string;
  corners: [
    [number, number],
    [number, number],
    [number, number],
    [number, number]
  ];
};
const MapImageLayer: React.FC<MapRasterLayerProps> = ({
  source,
  id,
  corners,
  belowLayer
}) => {
  const { map } = useContext(MapboxContainerContext);

  useEffect(() => {
    if (!map) return;

    map.addSource(id, {
      type: "image",
      url: source,
      coordinates: corners
    });
    map.addLayer(
      {
        id,
        source: id,
        type: "raster",
        paint: {}
      },
      belowLayer
    );

    return () => {
      map.removeSource(id);
      map.removeLayer(id);
    };
  }, [map, source, corners, id, belowLayer]);

  // No DOM output
  return null;
};

export default MapImageLayer;
